import { connect } from "react-redux";

import PatientDetailsForm from "../components/PatientDetailsForm";
import { withErrorBoundary } from "../../../../../components/custom/structure/components/ErrorBoundary";
import ErrorFallback from "../../../../../components/custom/structure/components/ErrorFallback";

const ConnectedPatientDetailsForm = connect()(PatientDetailsForm);

ConnectedPatientDetailsForm.displayName = "Patient Details Form";

export default withErrorBoundary(ConnectedPatientDetailsForm, {
  fallback: ErrorFallback,
});
